import { createContext } from 'react';

type NavigationBarContextType = {
  selectedActiveSectionName: string;
  setSelectedActiveSectionName: (name: string) => void;
};

const NavigationBarContext = createContext<NavigationBarContextType>({
  selectedActiveSectionName: '',
  setSelectedActiveSectionName: () => null,
});

export default NavigationBarContext;
